<template>
    <div class="files">
        <file-filters @filesUpdated="updateFiles" :selected="multipleSelection" @update-filters="onUpdateFilters" ref="filtersComponent"></file-filters>
        <div class="file-list">

            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} fichiers</div>
                <el-pagination @current-change="page => paginate(page, 'top')" :current-page.sync="params.page" :page-size="params.limit" :pager-count="11" layout="sizes, prev, pager, next" :page-sizes="page_sizes" @size-change="handleSizeChange" :total="total_item"></el-pagination>
                <button @click="openEdit()" class="btn btn-outline-secondary btn-sm">Créer</button>
            </div>
            <el-table style="width: 100%" ref="multipleTable" :data="files" @selection-change="handleSelectionChange" stripe @sort-change="changeSort" v-loading="loading">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="Nom" sortable="custom"></el-table-column>
                <el-table-column prop="filename" label="Fichier" sortable="custom"></el-table-column>
                <el-table-column prop="category" label="Categorie" sortable="custom">
                    <template slot-scope="scope">
                        <span>
                            {{ getCategoryName(scope.row.category) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="shop_id" label="ID Speedway" sortable="custom"></el-table-column>
                <el-table-column label="Actions" fixed="right">
                    <template slot-scope="scope">
                        <a :href="'/catalog?q=file:'+scope.row.id+appendSearch" v-if="scope.row.products_count">
                            <i class="fe fe-book-open"></i>
                            <span v-if="scope.row.search_query_count">/ {{ scope.row.search_query_count }}</span>
                        </a>
                        <a href="#" @click.prevent="openEdit(scope.row)" >
                            <i class="fe fe-edit"></i>
                        </a>
                        <a href="#" class="text-danger" @click.prevent="removeFile(scope.row)" >
                            <i class="fe fe-trash"></i>
                        </a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :page-size="params.limit" layout="sizes, prev, pager, next" :pager-count="11" :total="total_item" @current-change="page => paginate(page, 'bottom')" :page-sizes="page_sizes" @size-change="handleSizeChange" :current-page="params.page">
                </el-pagination>
            </div>
        </div>
        <el-dialog @closed="closeEdit" title="Création / Modification" v-loading="createEdit.loader" :visible.sync="createEdit.display" width="50%">
            <el-form class="formCreateEdit" ref="formCreateEdit" :rules="rules" :model="createEdit.form" label-position="top">
                <el-form-item prop="name" label="Nom">
                    <el-input v-model="createEdit.form.name"></el-input>
                </el-form-item>
                <el-form-item prop="file" label="Fichier">
                    <input ref="fileUpload" type="file">
                </el-form-item>
                <el-form-item prop="category" label="Catégorie">
                    <el-select v-model="createEdit.form.category" placeholder="Catégorie">
                        <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="createEdit.form.shop_id" prop="shop_id" label="ShopId">
                    <el-input disabled v-model="createEdit.form.shop_id"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="createEdit.display = false">Annuler</el-button>
                <el-button type="primary" @click="update">Enregistrer</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import queryString from 'query-string';
import { EventBus } from '../../event-bus';
import File from '../../models/File';
import categoryOptions from './categoryOptions'
export default {
    data() {
        return {
            multipleSelection: [],
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            filters: {},
            loading: false,
            categoryOptions: categoryOptions,
            rules: {
                name: [
                    {
                        required: true,
                        message: 'Veuillez renseignez un nom',
                        trigger: 'blur'
                    }
                ],
            },
            modal: {
                display: false,
                file: {}
            },
            createEdit: {
                display: false,
                loader: false,
                form: {
                }
            }
        };
    },
    computed: {
        total_item() {
            return this.$store.getters['files/totalItems'];
        },
        files() {
            return this.$store.getters['files/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
        appendSearch() {
            var query = this.params['product_search'] ? ' '+this.params['product_search'] + '&scope=name' : ''
            if( this.params.category_id ) {
                this.params.category_id.forEach((v)=>{
                    query += '&category_id='+v
                })
            }
            return query;
        }
    },
    watch: {
        params: {
            handler(newV, oldV) {
                var newUrl =
                    this.currentUrl + '?' + queryString.stringify(newV);
                window.history.pushState({ path: newUrl }, '', newUrl);
            },
            deep: true
        }
    },
    mounted() {
        this.$store.dispatch('app/setSearchMode', 'files');
        if (window.location.search) {
            var params = queryString.parse(window.location.search);
            for (let key in params) {
                switch (key) {
                    case 'page':
                    case 'limit':
                        params[key] = parseInt(params[key]);
                        break;
                    case 'file_id':
                    case 'manufacturer_id':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            parseInt(params[key]),
                            true
                        );
                        break;
                    case 'category_id':
                        if (typeof params[key] == 'Array') {
                            var value = params[key].map(v => parseInt(v));
                        } else {
                            var value = [parseInt(params[key])];
                        }

                        this.$refs.filtersComponent.setFilter(key, value, true);
                        break;
                    case 'q':
                        this.$store.dispatch('app/setQ', params[key]);
                        break;
                    case 'product_search':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            params[key],
                            true
                        );
                        break;
                    default:
                        break;
                }
            }
            this.params = params;
        }
        this.fetch();
    },

    methods: {
        getCategoryName(cat) 
        {
            let finded = categoryOptions.find( v => v.value == cat );
            if(!finded) {
                return null;
            }
            return finded.label;
        },
        removeFile(file)
        {
            this.$confirm('Ceci effacera la marque. Continuer?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Annuler',
                type: 'warning'
            }).then(() => {
                axios.delete('/files/'+file.id).then(()=>{
                    this.fetch()
                    this.$message({
                        type: 'success',
                        message: 'Marque supprimé'
                    });
                }).catch(()=>{

                })

            }).catch(() => {

            });
        },
        update()
        {
            this.$refs.formCreateEdit.validate((valid, errors) => {
                if (valid) {

                    let formSend = this.createEdit.form;
                    let axiosConfig = {};

                    if(this.$refs.fileUpload.files.length) {
                        let formData = new FormData();
                        formData.append('file', this.$refs.fileUpload.files[0]);
                        formData.append('name', this.createEdit.form.name);
                        formData.append('category', this.createEdit.form.category);

                        formSend = formData;
                        axiosConfig = {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    }

                    if( this.createEdit.form.id ) {
                        axios
                        .post('/files/' + this.createEdit.form.id, formSend, axiosConfig)
                        .then(r => {
                            this.closeEdit()
                            this.$message({
                                message: 'Fichier mise à jour.',
                                type: 'success'
                            });
                            this.fetch()
                        })
                        .catch(e => {
                            if (e.response && e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(
                                    'Erreur lors de la mise à jour.'
                                );
                                console.error(e)
                            }
                        })
                        .then(() => {});
                    } else {
                        axios
                        .post('/files', formSend, axiosConfig)
                        .then(r => {
                            this.closeEdit()
                            this.$message({
                                message: 'Fichier créer.',
                                type: 'success'
                            });
                            this.fetch()
                        })
                        .catch(e => {
                            if (e.response && e.response.status == 422) {
                                this.$message.error(e.response.data.errors);
                            } else {
                                this.$message.error(
                                    'Erreur lors de la mise à jour.'
                                );
                                console.error(e)
                            }
                        })
                        .then(() => {});
                    }

                }
            })
        },
        openEdit( file )
        {
            if( !file ) {
                file = new File
            }
            this.createEdit.form = file.toDatas();
            if(!this.createEdit.form.category) {
                this.createEdit.form.category = 'other'
            }
            this.createEdit.display = true;
        },
        closeEdit()
        {
            this.$refs.fileUpload.value = null
            this.createEdit.form = { };
            this.createEdit.display = false;
        },
        handleSelectionChange(val) {
            this.$store.dispatch('files/setApplyToAllResults', false);
            this.multipleSelection = val;
        },

        fetch(params) {
            if (!params) {
                params = {};
            }
            params = { ...params, ...this.params };
            this.loading = true;
            return this.$store.dispatch('files/fetch', params).then(() => {
                this.loading = false;
            });
        },

        updateFileInList(id, data) {
            this.$store.dispatch('files/updateInList', { id, data });
        },

        deleteFileInList(id) {
            this.$store.dispatch('files/removeInList', id);
        },

        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },

        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },

        onUpdateFilters(filters) {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...filters };
            if (!Object.values(filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },

        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },

        openModalEdit(file) {
            this.modal.display = true;
            this.modal.file = file.clone();
        },

        closeModalEdit() {
            this.modal.display = false;
        },

        onUpdateFile(file) {
            this.updateFileInList(file.id, file);
            this.$refs.filtersComponent.validFilters();
            this.closeModalEdit();
        },

        updateFiles(files) {
            this.$refs.multipleTable.clearSelection();
            files.forEach(file => {
                this.updateFileInList(file.id, file);
            });
        },

        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.files .file-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        },

        onDeleteFile(id) {
            this.deleteFileInList(id);
            this.closeModalEdit();
        },

        filterInTab(name, value) {
            this.$refs.filtersComponent.setFilter(name, value);
        }
    }
};
</script>
<style lang="scss">
.files {
    .pagination {
        margin: 25px 0;
        .el-pagination {
            margin: 0 auto;
        }
    }
}
</style>
